<template>
<div id="job-detail">
    <v-breadcrumbs :items="breadcrumbs" class="pt-0 pl-0">
        <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
        </template>
        <template v-slot:item="props">
            <router-link :to="props.item.to" :class="[props.item.disabled && 'disabled']">{{props.item.text}}</router-link>
        </template>
    </v-breadcrumbs>
    <v-layout class="align-center" flat grid-list-md>
        <v-flex>
            <v-card>
                <v-card-title>
                    <v-toolbar-title>Purchase Order Information</v-toolbar-title>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Purchase Order No:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.po_number}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Customer name:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.customer_name}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Gender:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{getGenderText(purchaseOrderInfo.gender)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Birthday:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.birthDay ? purchaseOrderInfo.birthDay.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/, "$3-$2-$1") : "" | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Customer Phone Number:</v-flex>
                                <v-flex md6 xs12 class="body-2" style="text-decoration: none; color: red">
                                    {{purchaseOrderInfo.phone_number}}
                                    <!--<a
                                            style="text-decoration: none; color: red"
                                            v-bind:href="'tel:' + purchaseOrderInfo.phone_number"
                                        >{{purchaseOrderInfo.phone_number}}</a>-->
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Customer Email Address:</v-flex>
                                <v-flex md6 xs12 class="body-2">
                                    <a style="text-decoration: none;" v-bind:href="'mailto:' + purchaseOrderInfo.email">{{purchaseOrderInfo.email}}</a>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Job Site Address:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.execution_address}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Province:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.province }}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Model:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.model && purchaseOrderInfo.model}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Warranty Expired Date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.warranty_expired_date | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Maintain Expired Date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.maintain_expired_date | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Salesperson’s email address:</v-flex>
                                <v-flex class="body-2" md6 xs12>
                                    <a style="text-decoration: none;" v-bind:href="'mailto:' + purchaseOrderInfo.seller_email_address">
                                        {{purchaseOrderInfo.seller_email_address}}</a>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="infoJob.type !== 1">
                                <v-flex md6 xs12>Next Maintain Date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.next_maintain_date | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="infoJob.type !== 1">
                                <v-flex md6 xs12>Most recent maintenance visit:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.prev_execution_date | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                            <!--<v-layout row wrap>
                                    <v-flex md6 xs12>Execution Date:</v-flex>
                                    <v-flex
                                            class="body-2"
                                            md6
                                            xs12
                                    >{{purchaseOrderInfo.createdAt | morph-date('YYYY/MM/DD')}}</v-flex>
                                </v-layout>-->
                        </v-flex>
                        <v-flex xs12>
                            <v-layout row wrap>
                                <v-flex md3 xs12>Assign users:</v-flex>
                                <v-flex class="body-2" md9 xs12>{{assign_users_view}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Brand:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.brand}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Note:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.note}}</v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex md6 xs12>File:</v-flex>
                                <v-flex class="body-2" md6 xs12>
                                    <div v-for="(file, key) in purchaseOrderInfo.files" :key="key" class="file-download">
                                        <p>{{ file.name || file.url }}</p>
                                        <a :href="file.url" download target="_blank">
                                            <v-btn flat icon color="rgba(0,0,0,0.54)">
                                                <i class="material-icons">file_download</i>
                                            </v-btn>
                                        </a>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance">
                                    <v-flex class="body-2" md12 xs12>Free maintenance:</v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance && purchaseOrderInfo.is_new_data">
                                    <v-flex md6 xs12>Number of periodic maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.form_free_maintenance && purchaseOrderInfo.form_free_maintenance.periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance && !purchaseOrderInfo.is_new_data">
                                    <v-flex md6 xs12>Number of periodic maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance && purchaseOrderInfo.is_new_data">
                                    <v-flex md6 xs12>Number of remaining periodic maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.form_free_maintenance && purchaseOrderInfo.form_free_maintenance.remaining_periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance && !purchaseOrderInfo.is_new_data">
                                    <v-flex md6 xs12>Number of remaining periodic maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.remaining_periodic_maintenance }}
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap v-if="purchaseOrderInfo.chargeable_maintenance">
                                    <v-flex class="body-2" md12 xs12>Chargeable maintenance:</v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.chargeable_maintenance">
                                    <v-flex md6 xs12>Number of charged maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.form_chargeable_maintenance && purchaseOrderInfo.form_chargeable_maintenance.periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.chargeable_maintenance">
                                    <v-flex md6 xs12>Number of remaining charged maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.form_chargeable_maintenance && purchaseOrderInfo.form_chargeable_maintenance.remaining_periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-flex md12 xs12 v-for="(row, index) in purchaseOrderInfo.form_chargeable_maintenance && purchaseOrderInfo.form_chargeable_maintenance.form_contact" :key="index">
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex class="body-2" md12 xs12>Maintenance contract information:</v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex md6 xs12>Maintenance contract number:</v-flex>
                                        <v-flex class="body-2" md6 xs12>{{ row.maintenance_contract_number }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex md6 xs12>Maintenance package:</v-flex>
                                        <v-flex class="body-2" md6 xs12>{{ row.maintenance_package }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex md6 xs12>Contract signing date:</v-flex>
                                        <v-flex class="body-2" md6 xs12>{{ row.contract_signing_date | morph-date('YYYY/MM/DD') }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex md6 xs12>Expiration time:</v-flex>
                                        <v-flex class="body-2" md6 xs12>{{ row.effective_time | morph-date('YYYY/MM/DD') }}
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
    <v-layout class="align-center">
        <v-flex xs12>
            <v-card>
                <v-card-title>
                    <v-toolbar-title>{{textContentBox}}</v-toolbar-title>
                </v-card-title>
                <v-card-text>
                    <v-layout v-if="infoJob.type === 1" wrap>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Execution Date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.createdAt | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Executor:</v-flex>
                                <v-flex class="body-2 check-width" md6 xs12><span v-html="genFullname(infoJob.performed_by)"></span></v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Required cut out size:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.cut_out_size}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>TH (as specified sales contract):</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.journey}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>No. of stops:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.floor}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>OH (as specified by sales contract):</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.overhead}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Pit:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.pit}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Installation location:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.localtion}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>U bracket/Fixing points:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.u_bracket}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Electricity:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.electricity}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Total lift weight:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{purchaseOrderInfo.total_lift_weight}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Most recent site check:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ infoJob.prev_execution_date | morph-date("YYYY/MM/DD") }}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Pit dimension:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.pit_dimension}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Pit structure:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.pit_structure}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Tel line/electricity calbe location:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.tel_line}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Pit depth:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.pit_depth}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Actual straightness of the shaft:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.actual_straightness}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Actual TH:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.actual_th}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Actual clear door opening:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.clear_door_opening}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Difference between beams that doors locate:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.between_beams}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Finished floors where the doors locate:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.finished_floor}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Straightness of staircase's inner side where there are fixing points:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.staircase_inner_side}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Straightness of shaft wall :</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.shaft_wall}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Shaft finishes at installation location:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.site_check.shaft_localtion}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Comment:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.comment}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{(infoJob.status) ? infoJob.status.name : ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 class="label" xs12>Work status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ getCompletionStatusText(infoJob.isCompleted) }}</v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout v-else-if="infoJob.type === 2" wrap>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Execution Date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.createdAt | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Executor:</v-flex>
                                <v-flex class="body-2 check-width" md6 xs12><span v-html="genFullname(infoJob.performed_by)"></span></v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Start time:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.start_time || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Status before maintenance:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.status_before}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>End time:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.end_time || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Status after maintenance:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.status_after}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Number of assignee:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.no_of_assignee || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Safety nut:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.safety_nut}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Effort:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.effort || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Door holders:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.door_holders}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra tasks:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{extra_tasks}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Brake:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.brake}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task number of assignee:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.extra_task_no_of_assignee || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Lubrication:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.lubrication}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task start time:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.extra_task_start_time || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Screws on motors:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.screws_on_motors}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task end time:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.extra_task_end_time || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Guide shoes/rollers:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.guide_shoes}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task repair reasons:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{extra_task_repair_reasons}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Guide rails:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.guide_rails}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task repair items:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{extra_task_repair_items}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Belt:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.belt}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task description:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.extra_task_description || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Platform cable:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.platform_cable}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Replaced spare parts:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{replaced_spare_parts || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Lighting system:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.lighting_system}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Payment method:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{payment_method}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Door cable:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.door_cable}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Total amount:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{total_amount}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Fixing points:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.fixing_points}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Auto door openers:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.auto_door_openers}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Latch bolts and hinges:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.latch_bolts_hinges}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Safety bar and safety edges:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.safety_bar_edges}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Emergency stop button:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.emergency_stop_button}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Alarm button:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.alarm_button}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Call buttons on control panels and doors:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.call_buttons_cp}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Electrical cabinet:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.electrical_cabinet}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Emergency lowering when there is a power cut-off:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.emergency_lowering}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Landing contacts:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.landing_contacts}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Limit switch:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.limit_switch}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Voltage and battery charger:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.vb_charger}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Tel signal:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.tel_signal}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Door opening by pit prop:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.door_opening_pit_prop}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Door opening with triangle key:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.door_opening_with_triangle}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Side E, guide rails, screw, pit cleaning:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.side_e_leaning}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>General lift operation:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.maintain.general_lift_operation}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Comment:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.comment}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{(infoJob.status) ? infoJob.status.name : ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Work status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ getCompletionStatusText(infoJob.isCompleted) }}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Periodic maintenance/Cleaning on demand:</v-flex>
                                <v-flex class="body-2" md6 xs12>
                                    {{infoJob.maintain.maintain_option === 1 ? "Bảo dưỡng định kỳ" : infoJob.maintain.maintain_option === 2 ? "Vệ sinh theo yêu cầu" : "Bảo dưỡng định kỳ"}}
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout v-else-if="infoJob.type === 3" wrap>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Execution Date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.createdAt | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Executor:</v-flex>
                                <v-flex class="body-2 check-width" md6 xs12><span v-html="genFullname(infoJob.performed_by)"></span></v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra tasks:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-html="extra_tasks"></v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Repair reason:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{(infoJob.repair) ? getRepairReason(infoJob.repair.repair_reason) : ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.repair.repair_reason_note">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Repair reason(note):</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.repair.repair_reason_note || ''}}</v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Repair items:</v-flex>
                                <v-flex class="body-2" md6 xs12>
                                    <div :key="index" v-for="(item, index) in infoJob.repair.repair_items">
                                        {{item.name}}
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task number of assignee:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.extra_task_no_of_assignee || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.repair.repair_items_note">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Repair items(note):</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.repair.repair_items_note || ''}}</v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex md6 xs12 v-if="infoJob.repair.replaced_spare_part_note">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Replaced spare part(note):</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.repair.replaced_spare_part_note || ''}}</v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task start time:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.extra_task_start_time || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Repair works/Emergency repair works:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.repair.description}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task repair reasons:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{extra_task_repair_reasons}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task end time:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.extra_task_end_time || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task repair items:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{extra_task_repair_items}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Extra task description:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.extra_task_description || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Replaced spare parts:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{replaced_spare_parts}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Payment method:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{payment_method}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Total amount:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{total_amount}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Comment:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.comment}}</v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{(infoJob.status) ? infoJob.status.name : ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Work status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ getCompletionStatusText(infoJob.isCompleted) }}</v-flex>
                            </v-layout>
                        </v-flex>

                    </v-layout>
                    <v-layout v-else-if="infoJob.type === 5" wrap>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Work status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ getCompletionStatusText(infoJob.isCompleted) }}</v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout v-else-if="infoJob.type === 7" wrap>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Execution Date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.createdAt | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Executor:</v-flex>
                                <v-flex class="body-2 check-width" md6 xs12><span v-html="genFullname(infoJob.performed_by)"></span></v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Installation address:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.safety_assessment.installation_address || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Sales representative:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.safety_assessment.sales_representative || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Signer:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.signer || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Signature:</v-flex>
                                <v-flex class="body-2" md6 xs12>
                                    <a style="text-decoration: none;" v-bind:href="infoJob.signature" target="_blank">{{infoJob.signature || ''}}</a>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Team leader:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-for="(row, index) in infoJob.safety_assessment.team_leader" :key="index">
                                    <span>
                                        {{ row }}
                                    </span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Member:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-for="(row, index) in infoJob.safety_assessment.member" :key="index">
                                    <span>
                                        {{ row }}
                                    </span>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Work status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ getCompletionStatusText(infoJob.isCompleted) }}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md12 xs12 class="item_question">
                            Answers:
                        </v-flex>
                        <v-flex md12 xs12>
                            <v-layout wrap v-for="(row, index) in infoJob.safety_assessment.answers" :key="index">
                                <v-flex md12 xs12>{{ index + 1 }}.{{ row.description }}</v-flex>
                                <v-flex md6 xs12>answer: <span class="body-2">{{ row.answer }}</span></v-flex>
                                <v-flex md6 xs12 v-if="row.notes">notes: <span class="body-2">{{ row.notes }}</span></v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout v-else-if="infoJob.type === 8" wrap>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Survey Date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.updatedAt | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Work status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ getCompletionStatusText(infoJob.isCompleted) }}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Address:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.address}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Available power supply:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.available_power_supply}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Clearance size:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.clearance_size}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Cruise height:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.cruise_height}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Customer name:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.customer_name}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Depth and pit structure:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.depth_and_pit_structure}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Installation location:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.installation_location}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Installation type:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.installation_type}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Phone number:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.phone_number}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Project type:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.project_type}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Reference number:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.reference_name}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Surveyor name:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.surveyor_name}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Top floor height:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.survey.top_floor_height}}</v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout v-else wrap>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Installation date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.createdAt | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Complete date:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.time_completed_installation | morph-date('YYYY/MM/DD')}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12>
                            <v-layout row wrap>
                                <v-flex md6 xs12>Work status:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{ getCompletionStatusText(infoJob.isCompleted) }}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-layout row wrap>
                                <v-flex md3 xs12>Performed by:</v-flex>
                                <v-flex class="body-2 check-width" md9 xs12>{{performedInstallation}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Images Received:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-if="infoJob.installation.images_received.length > 0">
                                    <v-layout class="block-images">
                                        <div :key="index" md3 xs3 v-for="(item, index) in infoJob.installation.images_received">
                                            <img class="style-images" v-on:click="showPopupImg(item)" :src="item" onerror="this.onerror=null;this.src='/images/no-image.png';" />
                                        </div>
                                    </v-layout>
                                    <v-dialog max-width="700" v-model="dialogImg">
                                        <div class="slider-image">
                                            <img :src="imgPopup" onerror="this.onerror=null;this.src='/images/no-image.png';">
                                        </div>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Note:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-if="infoJob.installation.note_img_received && infoJob.installation.note_img_received.length> 0">
                                    <div>{{infoJob.installation.note_received || ''}}</div>
                                    <v-layout class="block-images">
                                        <div :key="index" v-for="(item, index) in infoJob.installation.note_img_received">
                                            <img v-on:click="showPopupImg(item)" class="style-images" :src="item" onerror="this.onerror=null;this.src='/images/no-image.png';" />
                                        </div>
                                    </v-layout>
                                    <v-dialog max-width="700" v-model="dialogImg">
                                        <div class="slider-image">
                                            <img :src="imgPopup" onerror="this.onerror=null;this.src='/images/no-image.png';">
                                        </div>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Status Before Installation:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-if="infoJob.installation.images_status_before_installation && infoJob.installation.images_status_before_installation.length > 0">
                                    <v-layout class="block-images">
                                        <div :key="index" v-for="(item, index) in infoJob.installation.images_status_before_installation">
                                            <img v-on:click="showPopupImg(item)" class="style-images" :src="item" onerror="this.onerror=null;this.src='/images/no-image.png';" />
                                        </div>
                                    </v-layout>
                                    <v-dialog max-width="700" v-model="dialogImg">
                                        <div class="slider-image">
                                            <img :src="imgPopup" onerror="this.onerror=null;this.src='/images/no-image.png';">
                                        </div>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Note During Installation:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.installation.note_during_installation}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Status After Installation:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-if="infoJob.installation.images_status_after_installation && infoJob.installation.images_status_after_installation.length > 0">
                                    <v-layout class="block-images">
                                        <div :key="index" v-for="(item, index) in infoJob.installation.images_status_after_installation">
                                            <img v-on:click="showPopupImg(item)" class="style-images" :src="item" onerror="this.onerror=null;this.src='/images/no-image.png';" />
                                        </div>
                                    </v-layout>
                                    <v-dialog max-width="700" v-model="dialogImg">
                                        <div class="slider-image">
                                            <img :src="imgPopup" onerror="this.onerror=null;this.src='/images/no-image.png';">
                                        </div>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Note After Installation:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.installation.note_after_installation}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Note For Deliverable:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-if="infoJob.installation.note_img_for_deliverable && infoJob.installation.note_img_for_deliverable.length > 0">
                                    <div>{{infoJob.installation.note_for_deliverable || ''}}</div>
                                    <v-layout class="block-images">
                                        <div :key="index" v-for="(item, index) in infoJob.installation.note_img_for_deliverable">
                                            <img v-on:click="showPopupImg(item)" class="style-images" :src="item" onerror="this.onerror=null;this.src='/images/no-image.png';" />
                                        </div>
                                    </v-layout>
                                    <v-dialog max-width="700" v-model="dialogImg">
                                        <div class="slider-image">
                                            <img :src="imgPopup" onerror="this.onerror=null;this.src='/images/no-image.png';">
                                        </div>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Labor Safety Tool:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-if="infoJob.installation.images_labor_safety_tools && infoJob.installation.images_labor_safety_tools.length > 0">
                                    <v-layout class="block-images">
                                        <div :key="index" v-for="(item, index) in infoJob.installation.images_labor_safety_tools">
                                            <img v-on:click="showPopupImg(item)" class="style-images" :src="item" onerror="this.onerror=null;this.src='/images/no-image.png';" />
                                        </div>
                                    </v-layout>
                                    <v-dialog max-width="700" v-model="dialogImg">
                                        <div class="slider-image">
                                            <img :src="imgPopup" onerror="this.onerror=null;this.src='/images/no-image.png';">
                                        </div>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Labor Safety Method:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-if="infoJob.installation.images_labor_safety_method && infoJob.installation.images_labor_safety_method.length > 0">
                                    <v-layout class="block-images">
                                        <div :key="index" v-for="(item, index) in infoJob.installation.images_labor_safety_method">
                                            <img v-on:click="showPopupImg(item)" class="style-images" :src="item" onerror="this.onerror=null;this.src='/images/no-image.png';" />
                                        </div>
                                    </v-layout>
                                    <v-dialog max-width="700" v-model="dialogImg">
                                        <div class="slider-image">
                                            <img :src="imgPopup" onerror="this.onerror=null;this.src='/images/no-image.png';">
                                        </div>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Accident:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.installation.accident || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Solution:</v-flex>
                                <v-flex class="body-2" md6 xs12>{{infoJob.installation.solution || ''}}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md6 xs12 v-if="infoJob.installation">
                            <v-layout row wrap>
                                <v-flex md6 xs12>Cleaning After Installation:</v-flex>
                                <v-flex class="body-2" md6 xs12 v-if="infoJob.installation.images_cleaning_after_installation && infoJob.installation.images_cleaning_after_installation.length > 0">
                                    <v-layout class="block-images">
                                        <div :key="index" v-for="(item, index) in infoJob.installation.images_cleaning_after_installation">
                                            <img v-on:click="showPopupImg(item)" class="style-images" :src="item" onerror="this.onerror=null;this.src='/images/no-image.png';" />
                                        </div>
                                    </v-layout>
                                    <v-dialog max-width="700" v-model="dialogImg">
                                        <div class="slider-image">
                                            <img :src="imgPopup" onerror="this.onerror=null;this.src='/images/no-image.png';">
                                        </div>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
    <v-layout class="align-center grid-image-job" v-if="infoJob.type != 5 && infoJob.type != 6">
        <v-flex xs12>
            <v-card>
                <v-card-title>
                    <v-toolbar-title>Images</v-toolbar-title>
                </v-card-title>
                <v-card-text v-if="listImages.length > 0">
                    <v-layout wrap list-images>
                        <v-flex :key="index" md3 xs3 v-for="(item, index) in listImages">
                            <v-card class="d-flex" flat tile v-on:click="showPopupImg(item)">
                                <!--<v-img :src="item" aspect-ratio="1" class="grey lighten-2">
                                        <template v-slot:placeholder>
                                            <v-layout align-center fill-height justify-center ma-0>
                                                <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                                            </v-layout>
                                        </template>
                                    </v-img>-->
                                <div>
                                    <img :src="item" onerror="this.onerror=null;this.src='/images/no-image.png';" />
                                </div>

                            </v-card>
                        </v-flex>

                        <!--<LightBox :images="listImages"></LightBox>-->
                    </v-layout>

                    <v-dialog max-width="700" v-model="dialogImg">
                        <div class="slider-image">
                            <img :src="imgPopup" onerror="this.onerror=null;this.src='/images/no-image.png';">
                        </div>
                    </v-dialog>
                </v-card-text>
                <v-card-text v-else>{{textStatusImg}}</v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
    <v-layout class="grid-controll" v-bind:class="{'full-div': !drawer}">
        <v-flex xs12>
            <div class="list-btn">
                <v-btn @click="exportData" color="primary" small>Export</v-btn>
                <v-btn @click="$router.go(-1)" small>Cancel</v-btn>
            </div>
        </v-flex>
    </v-layout>
</div>
</template>

<script>
import JobService from "../services/job.service";
import RepairReasonService from "../services/repair.reason.service";
import PurchaseOrderService from "../services/purchase.order.service";
import {
    extraTaskConst
} from '../common/Constants';
import genderList from "../config/genders";
// import { isEmpty, debounce } from "lodash";
// import LightBox from 'vue-image-lightbox';
// import { setTimeout } from "timers";
export default {
    metaInfo() {
        return {
            title: "View Job Detail"
        };
    },
    data: () => ({
        breadcrumbs: [{
                text: 'Purchase Order',
                disabled: false,
                to: '/purchase-order'
            },
            {
                text: 'Job',
                disabled: false,
                to: '/purchase-order'
            },
            {
                text: 'Detail',
                disabled: true,
                to: ''
            }
        ],
        infoJob: {
            repair: {},
            site_check: {},
            maintain: {},
            safety_assessment: {},
            survey: {}
        },
        jobService: new JobService(),
        repairReasonService: new RepairReasonService(),
        purchaseOrderService: new PurchaseOrderService(),
        dialogImg: false,
        purchaseOrderInfo: {},
        listImages: [],
        listRepairReasons: [],
        textStatusImg: '',
        imgPopup: "",
        isExport: false,
        performedInstallation: [],
        assign_users_view: "",
    }),
    created() {
        this.getInfoPurchaseOrder();
        this.getDetailJob();
        this.getListRepairReasons();
        // console.log(this.$route.params.idPO);
        this.breadcrumbs[1].to = '/purchase-order/' + this.$route.params.idPO;

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    watch: {},
    computed: {
        textContentBox: function () {
            const type = this.infoJob.type;
            let result = '';
            switch (type) {
                case 1:
                    result = 'Site Check Detail';
                    break;
                case 2:
                    result = 'Maintain Detail';
                    break;
                case 3:
                    result = 'Repair Detail';
                    break;
                case 5:
                    result = 'Acceptance Detail';
                    break;
                case 6:
                    result = 'Preliminary Detail';
                    break;
                case 7:
                    result = 'Safety Assessment Detail';
                    break;
                case 8:
                    result = 'Survey Detail';
                    break;
                default:
                    result = 'Installation Detail'
                    break;
            }
            return result
        },
        drawer: function () {
            return this.$store.getters["common/getDrawerTogged"];
        }
    },
    methods: {
        getDetailJob() {
            this.jobService.getDetail(this.$route.params.idJOB).then(res => {
                // console.log(res);
                if (res.data !== undefined) {
                    this.infoJob = res.data;
                    this.replaced_spare_parts = '';
                    if (res.data.replaced_spare_parts && res.data.replaced_spare_parts.length > 0) {
                        this.replaced_spare_parts = res.data.replaced_spare_parts.map((e) =>
                                e.replaced_spare_part +
                                ' x ' +
                                e.replace_spare_part_qty +
                                ' = ' +
                                e.sub_total_amount.toLocaleString() +
                                ' VNĐ'
                            )
                            .join('</br>');
                    }

                    this.total_amount = '';
                    if (res.data.total_amount) {
                        this.total_amount = res.data.total_amount.toLocaleString() + ' VNĐ';
                    }

                    this.extra_tasks = '';
                    if (res.data.extra_tasks && res.data.extra_tasks.length) {
                        const extra_task_names = res.data.extra_tasks.map(e => e.name);
                        const index = extra_task_names.indexOf(extraTaskConst.Khac);
                        if (index !== -1) {
                            extra_task_names[index] += ': ' + res.data.extra_task_detail;
                        }
                        this.extra_tasks = extra_task_names.join(',</br>');
                    }

                    this.extra_task_repair_reasons = '';
                    if (res.data.extra_task_repair_reasons && res.data.extra_task_repair_reasons.length) {
                        const extra_task_repair_reason_names = res.data.extra_task_repair_reasons.map(e => e.name);
                        const index = extra_task_repair_reason_names.indexOf(extraTaskConst.Khac);
                        if (index !== -1) {
                            extra_task_repair_reason_names[index] += ': ' + res.data.extra_task_repair_reason_detail;
                        }
                        this.extra_task_repair_reasons = extra_task_repair_reason_names.join(',</br>');
                    }

                    this.extra_task_repair_items = '';
                    if (res.data.extra_task_repair_items && res.data.extra_task_repair_items.length) {
                        const extra_task_repair_item_names = res.data.extra_task_repair_items.map(e => e.name);
                        this.extra_task_repair_items = extra_task_repair_item_names.join(', ');
                    }

                    this.payment_method = '';
                    if (res.data.payment_method) {
                        this.payment_method = res.data.payment_method.name;
                    }

                    if (this.infoJob.images && this.infoJob.images.length > 0) {
                        this.infoJob.images.forEach(v => {
                            if (v.match(/\.(jpeg|jpg|gif|png)$/) != null) {
                                this.listImages.push(v);
                            }
                        });
                    } else {
                        this.textStatusImg = 'There is no images!';
                    }
                    if (this.infoJob.installation) {
                        if (!this.purchaseOrderInfo.assign_users || this.purchaseOrderInfo.assign_users.length === 0) {
                            return;
                        }
                        if (!this.infoJob.performed_installation || this.infoJob.performed_installation.length === 0) {
                            return;
                        }
                        const listAssignee = this.purchaseOrderInfo.assign_users.filter((assignee) => this.infoJob.performed_installation.includes(assignee.id));
                        if (!listAssignee || listAssignee.length === 0) {
                            return;
                        }
                        this.performedInstallation = listAssignee.map(e => this.genPlainFullName(e)).join(', ');
                    }
                }
            });
        },
        getInfoPurchaseOrder() {
            this.purchaseOrderService
                .getDetail(this.$route.params.idPO)
                .then(res => {
                    this.purchaseOrderInfo = res.data;
                    if (
                        this.purchaseOrderInfo &&
                        this.purchaseOrderInfo.assign_users.length > 0
                    )
                        this.assign_users_view = this.purchaseOrderInfo.assign_users.map(e => this.genPlainFullName(e)).join(', ');
                });
        },
        showPopupImg(item) {
            this.dialogImg = true;
            this.imgPopup = item;
        },
        exportData() {
            const fileUrl = this.infoJob.url;
            if (fileUrl !== '') {
                window.open(fileUrl);
            }
        },
        genFullname(info) {
            if (!info) return '';
            if (!info.first_name) info.first_name = '';
            if (!info.last_name) info.last_name = '';

            return info.first_name + ' ' + info.last_name + ' <<a style="text-decoration: none;" v-bind:href="mailto: + ' + info.email + '">' + info.email + ' </a>>';
        },

        genPlainFullName(info) {
            if (!info) return '';
            if (!info.first_name) info.first_name = '';
            if (!info.last_name) info.last_name = '';

            return info.first_name + ' ' + info.last_name + ' <' + info.email + '>';
        },

        getListRepairReasons() {
            this.repairReasonService.getRepairReasons().then((data) => this.listRepairReasons = data)
        },

        getRepairReason(id) {
            if (this.listRepairReasons && this.listRepairReasons.length) {
                return this.listRepairReasons.find(r => r.id === id).name || '';
            }
            return ''
        },
        getCompletionStatusText(isCompleted) {
            switch (isCompleted) {
                case void "":
                case true:
                    return "Đã hoàn thành";
                case false:
                    return "Chưa hoàn thành";
                default:
                    return "Không xác định";
            }
        },
        getGenderText(gender) {
            const mapping = genderList.find(m => m.value === gender);
            if (typeof mapping === "undefined") {
                return "Unknown";
            }
            return mapping.text;
        }
    },
    components: {
        // LightBox
    }
};
</script>

<style>
.slider-image img {
    max-width: 100%;
    display: block;
}

#job-detail {
    position: relative;
}

#job-detail .grid-controll {
    position: fixed;
    bottom: 0;
    width: calc(100% - 260px);
    right: 4px;
    background: #fff;
    box-shadow: 0px -1px 2px #ccc;
    height: 55px;
}

#job-detail .grid-controll.full-div {
    width: 100%
}

#job-detail .grid-controll .list-btn {
    display: flex;
    justify-content: center;
}

.v-card__title {
    font-size: 18px;
    font-weight: bold;
    background-color: #f5f5f5;
}

.check-width {
    word-break: break-word;
}

.grid-image-job .list-images img {
    max-width: 100%;
}

.theme--light.v-breadcrumbs a {
    text-decoration: none;
    font-size: 16px;
}

.theme--light.v-breadcrumbs .disabled {
    color: rgba(0, 0, 0, 0.87);
    cursor: auto;
}

#job-detail .grid-image-job {
    margin-bottom: 50px;
}

.body-2 {
    word-break: break-word;
}

.style-images {
    max-width: 90px;
    width: 90px;
    height: 90px;
    max-height: 90px;
    margin-right: 5px;
    border: 1px solid #bbbbbb;
}

.block-images {
    padding-left: 5px;
    overflow-x: auto;
}
.item_question {
    font-size: 16px !important;
    font-weight: 400;
    line-height: 1 !important;
    letter-spacing: 0.02em !important;
    font-family: 'Roboto', sans-serif !important;
    margin: 1rem 0;
}
</style>
